import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bf637fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "self-center pr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pill flex rounded-full items-center", _ctx.classNames])
  }, [
    (this.$slots.icon ? this.$slots.icon().length > 0 : false)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["pill__icon mr-2 grid place-items-center rounded-full", [_ctx.iconClassNames, _ctx.sizeClasses]])
        }, [
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 2))
}